import IState from '../models/IState';
import { createSelector } from "reselect";

const stateIAQSensorDataChart = (state: IState) => state.iaqSensorDataChart.sensorDataChartList.datas;

export const allIAQSensorDataChart = createSelector(
    stateIAQSensorDataChart,
    (datas) => {
        if (datas !== null && datas !== undefined) {
            return datas;
        }
        return [];
    }
);




